export const dispatchSubmit = (id: string) => {
    document.getElementById(id)?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
}
